module.exports = __webpack_public_path__ + "img/analytics_21e3788.png";